var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            "append-to-body": true,
            "close-on-click-modal": false,
            "show-close": true,
            title: _vm.$t("GlobalSetObj.ShippingAddress"),
            visible: _vm.fixAddress,
            direction: "ltr",
            size: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.fixAddress = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                padding: "0 15px",
                height: "calc(100% - 50px)",
                "overflow-y": "auto",
              },
            },
            [
              _c("div", { staticClass: "address-compact-container" }, [
                _c("div", { staticClass: "address-row" }, [
                  _c("div", { staticClass: "address-label" }, [
                    _c("i", {
                      staticClass: "el-icon-location",
                      staticStyle: { color: "#009944", "margin-right": "4px" },
                    }),
                    _vm._v(
                      _vm._s(_vm.$t("scripting.currentAddressInfo")) + ": "
                    ),
                  ]),
                  _c("div", { staticClass: "address-content" }, [
                    _c("span", { staticClass: "address-text" }, [
                      _vm._v(_vm._s(_vm.originalAddress)),
                    ]),
                  ]),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "flex-start",
                  staticStyle: {
                    margin: "10px 0",
                    padding: "10px",
                    "background-color": "#f5f6fb",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "address-label",
                      staticStyle: { color: "#1e2a3a" },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("scripting.newAddressSearch")) + " "
                      ),
                    ]
                  ),
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "80%" },
                      attrs: {
                        placeholder: _vm.$t(
                          "scripting.enterFullAddressToSearch"
                        ),
                        clearable: "",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.doSearch($event)
                        },
                      },
                      model: {
                        value: _vm.searchText,
                        callback: function ($$v) {
                          _vm.searchText = $$v
                        },
                        expression: "searchText",
                      },
                    },
                    [
                      _c("el-button", {
                        attrs: { slot: "append", icon: "el-icon-search" },
                        on: { click: _vm.doSearch },
                        slot: "append",
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "flex-start address-compact-container",
                  staticStyle: {
                    margin: "10px 0",
                    padding: "10px",
                    background: "none",
                  },
                },
                [
                  _c("div", { staticClass: "address-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("scripting.addressSupplementOptional"))
                    ),
                  ]),
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      maxlength: 100,
                      placeholder: _vm.$t("scripting.addressSupplementExample"),
                      rows: 1,
                      clearable: "",
                      type: "textarea",
                    },
                    model: {
                      value: _vm.addressSupplement,
                      callback: function ($$v) {
                        _vm.addressSupplement = $$v
                      },
                      expression: "addressSupplement",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        color: "#969eb5",
                        padding: "10px",
                        background: "#f5f6fb",
                        "border-radius": "8px",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("scripting.supplementaryInfoNotice")) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "address-display-container" }, [
                _c(
                  "div",
                  { staticStyle: { color: "#1e2a3a", "font-weight": "bold" } },
                  [
                    _c("i", {
                      staticClass: "el-icon-location",
                      staticStyle: { color: "#009944", "margin-right": "4px" },
                    }),
                    _vm._v(
                      " " + _vm._s(_vm.$t("scripting.newAddressInfo")) + "： "
                    ),
                  ]
                ),
                _c("div", { staticClass: "address-section core-address" }, [
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("placeOrder.zipcode")) + "："),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "value",
                        class: {
                          "missing-value": !_vm.localForm.receiveZipcode,
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.localForm.receiveZipcode || "--") +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("placeOrder.State")) + "："),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "value",
                        class: { "missing-value": !_vm.localForm.receiveState },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.localForm.receiveState || "--") + " "
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("placeOrder.city")) + "："),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "value",
                        class: { "missing-value": !_vm.localForm.receiveCity },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.localForm.receiveCity || "--") + " "
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("placeOrder.Area")) + "："),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "value",
                        class: { "missing-value": !_vm.localForm.receiveArea },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.localForm.receiveArea || "--") + " "
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("newOrder.Street")) + "："),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "value",
                        class: {
                          "missing-value": !_vm.localForm.receiveStreet,
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.localForm.receiveStreet || "--") +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("placeOrder.HouseNumber")) + "："),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "value",
                        class: {
                          "missing-value": !_vm.localForm.receiveHouseNumber,
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.localForm.receiveHouseNumber || "--") +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("placeOrder.addressComplement")) + "："
                      ),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "value",
                        class: {
                          "missing-value": !_vm.localForm.receiveComplement,
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.addressSupplement ||
                                _vm.localForm.receiveComplement ||
                                "--"
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("placeOrder.detailedAddress")) + "："
                      ),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "value",
                        class: {
                          "missing-value": !_vm.localForm.receiveAddress,
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.localForm.receiveAddress || "--") +
                            " "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "map-container", attrs: { id: "map" } }),
              _c(
                "div",
                {
                  staticStyle: {
                    position: "absolute",
                    bottom: "5px",
                    right: "30px",
                    "z-index": "9999",
                  },
                },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "small" }, on: { click: _vm.closeForm } },
                    [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Cancelar")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "warning" },
                      on: { click: _vm.validateAddress },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("scripting.verifyAddressValidity")) + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            visible: _vm.confirmDialog,
            top: "10vh",
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.confirmDialog = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function () {
                return [
                  _c("div", { staticClass: "flex-start" }, [
                    _c("div", [
                      _c("span", {
                        staticClass: "iconfont icon-wenhaoxiao",
                        staticStyle: { color: "#409eff" },
                      }),
                    ]),
                    _c("div", [
                      _vm._v(_vm._s(_vm.$t("scripting.confirmAddressChange"))),
                    ]),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "confirm-address-box" }, [
            _c("p", { staticClass: "dialog-desc" }, [
              _vm._v(_vm._s(_vm.$t("scripting.confirmAddressInfoNotice"))),
            ]),
            _c("div", { staticClass: "address-card" }, [
              _c("div", { staticClass: "addr-item" }, [
                _c("span", { staticClass: "addr-label" }, [
                  _c("i", {
                    staticClass: "el-icon-location",
                    staticStyle: { color: "#409eff", "margin-right": "6px" },
                  }),
                  _vm._v(" " + _vm._s(_vm.$t("scripting.newAddress")) + " "),
                ]),
                _c("div", { staticClass: "addr-value" }, [
                  _vm._v(
                    " " + _vm._s(_vm.localForm.receiveAddress || "--") + " "
                  ),
                ]),
              ]),
              _c("div", { staticClass: "flx-between" }, [
                _c("div", { staticClass: "addr-col" }, [
                  _c("div", { staticClass: "addr-label" }, [
                    _vm._v(_vm._s(_vm.$t("scripting.longitude"))),
                  ]),
                  _c("div", { staticClass: "addr-value" }, [
                    _vm._v(_vm._s(_vm.showLng || "--")),
                  ]),
                ]),
                _c("div", { staticClass: "addr-col" }, [
                  _c("div", { staticClass: "addr-label" }, [
                    _vm._v(_vm._s(_vm.$t("scripting.latitude"))),
                  ]),
                  _c("div", { staticClass: "addr-value" }, [
                    _vm._v(_vm._s(_vm.showLat || "--")),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "warning-tip" }, [
              _c("i", {
                staticClass: "el-icon-info",
                staticStyle: { color: "#409eff", "margin-right": "6px" },
              }),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("scripting.notifyReplaceWaybillNotice"))),
              ]),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.confirmDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("WorkCentreTable.cancel")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirmEdit } },
                [_vm._v(_vm._s(_vm.$t("scripting.confirmAddressChange")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }